import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import {
    fetchLocationData,
    setSelectedClient,
    setSelectedBranch,
    resetFilters,
    selectClients,
    selectSelectedClient,
    selectSelectedBranch,
    selectFilteredBranches,
    selectLoading
} from '../store/slices/locationSlice';
import './CategoryMaster.css';

const LocationHeader = () => {
    const dispatch = useDispatch();
    const clients = useSelector(selectClients);
    const selectedClient = useSelector(selectSelectedClient);
    const selectedBranch = useSelector(selectSelectedBranch);
    const filteredBranches = useSelector(selectFilteredBranches);
    const loading = useSelector(selectLoading);

    useEffect(() => {
        dispatch(
            fetchLocationData({
                rolename: localStorage.getItem('role') || '',
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    }, [dispatch]);

    const handleReset = () => {
        dispatch(resetFilters());
        dispatch(
            fetchLocationData({
                rolename: localStorage.getItem('role') || '',
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    };

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Location Master
                </h2>
                <p className="text-color-secondary">View and manage location records filtered by client and branch</p>
            </div>

            <Card className="mb-4 bill-reports-filter-card">
                <div className="flex flex-wrap gap-4 align-items-end bill-reports-filter-row">
                    <div className="flex flex-column" style={{ flex: '1 1 220px', minWidth: '220px' }}>
                        <label className="mb-2 font-medium text-sm">Client</label>
                        <Dropdown
                            value={selectedClient}
                            options={clients}
                            onChange={(e) => dispatch(setSelectedClient(e.value))}
                            optionLabel="client_name"
                            placeholder="Select Client"
                            className="w-full"
                            filter
                            showClear
                        />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 220px', minWidth: '220px' }}>
                        <label className="mb-2 font-medium text-sm">Branch</label>
                        <Dropdown
                            value={selectedBranch}
                            options={filteredBranches}
                            onChange={(e) => dispatch(setSelectedBranch(e.value))}
                            optionLabel="branch_name"
                            placeholder={selectedClient ? 'Select Branch' : 'Select Client First'}
                            className="w-full"
                            filter
                            showClear
                            disabled={!selectedClient}
                        />
                    </div>

                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleReset} disabled={loading} />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default LocationHeader;
